import axios, { AxiosError } from "axios";
const ConsignmentResource = {
    get(consignmentId, resultFunc, errorFunc, finallyFunc) {
        axios.get(`/admin/v1/consignments/${consignmentId}`)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    search(searchParams, resultFunc, errorFunc, finallyFunc) {
        axios.get("/admin/v1/consignments", { params: searchParams })
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    getBillable(consignmentId, resultFunc, errorFunc, finallyFunc) {
        axios.get(`/admin/v1/consignments/${consignmentId}/billable`)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    approveDebtorInvoice(consignmentId, resultFunc, errorFunc, finallyFunc) {
        axios.patch(`/admin/v1/consignments/${consignmentId}/approve-debtor-invoice`)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    approveBulkDebtorInvoices(consignmentIds, resultFunc, errorFunc, finallyFunc) {
        axios.patch(`/admin/v1/consignments/approve-debtor-invoices`, { consignmentIds })
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    searchAndIncSuggestedVehicleTypeInResponse(searchParams, resultFunc, errorFunc, finallyFunc) {
        searchParams.incSuggestedVehicleTypeInResponse = true;
        axios.get("/admin/v1/consignments", { params: searchParams })
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    appointCarrier(consignmentId, consignmentVersion, carrierTenantId, resultFunc, errorFunc, finallyFunc) {
        axios.put(`/admin/v1/consignments/${consignmentId}/appoint-carrier/${carrierTenantId}?version=${consignmentVersion}`)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
};
export default ConsignmentResource;
